




































import { Component, Prop, Watch } from 'vue-property-decorator';
import CommonVue from '@/models/commonVue';
import { BusEvent } from '@/models/bus';

import ApiList from '@/api/list';
import ArrowIcon from '@/components/icons/ArrowIcon.vue';
import ListCourse from '@/components/listView/ListCourse.vue';
import Course from '@/api/course';
import EditCourse from '@/editComponents/EditCourse.vue';
@Component({
  components: {
    'arrow-icon': ArrowIcon,
    'list-course': ListCourse,
    'edit-course': EditCourse,
  },
})
export default class CourseView extends CommonVue {
  @Prop({ type: String }) public entity!: string;
  @Prop() public id: number;
  @Prop({ type: Boolean, default: false }) public isEdit!: boolean;

  public courses?: Promise<ApiList<Course>> = undefined;

  public beforeMount() {
    this.getList();

    this.$bus.$on(BusEvent.CACHE_CHANGED, () => {
      this.getList();
    });
  }

  @Watch('entity')
  public getList() {
    this.courses = Course.listAll();
  }
}
